import { render, staticRenderFns } from "./SearchView.vue?vue&type=template&id=0a5b9aa2&scoped=true&"
import script from "./SearchView.vue?vue&type=script&lang=js&"
export * from "./SearchView.vue?vue&type=script&lang=js&"
import style0 from "./SearchView.vue?vue&type=style&index=0&id=0a5b9aa2&lang=scss&scoped=true&"
import style1 from "./SearchView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5b9aa2",
  null
  
)

export default component.exports